module.exports = __webpack_public_path__ + "officialStatic/img/auth1.eda2d1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/auth1.jpg
// module id = rV+k
// module chunks = 0